export class GenerateHTMLForPrint {
    static getInitHTML(){
      return "<html><head><link rel=\"stylesheet\" href=\"/print.css\" media=\"print\" /><script src=\"https://unpkg.com/pagedjs/dist/paged.polyfill.js\"></script></head><body>"
    }
  
    static getLastHTML() {
      return "</body></html>"
    }
  }
  